import { jsx as a, jsxs as l } from "react/jsx-runtime";
import d from "react";
import { styled as n, css as i } from "styled-components";
import { D as o, R as g } from "../chunks/Description.be3b00d1.js";
const r = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right"
}, m = n.div.withConfig({
  displayName: "Host",
  componentId: "sc-10bagjr-0"
})(["display:block;box-sizing:border-box;position:relative;width:fit-content;"]), v = n.div.withConfig({
  displayName: "RangoTooltip",
  componentId: "sc-10bagjr-1"
})(["&:hover{", "{opacity:1;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);}}", "{box-sizing:border-box;position:absolute;opacity:0;word-break:break-word;color:var(--inverse-description-color);background-color:var(--elements-bg-color-03);width:max-content;max-width:var(--size-30x);padding:var(--spacing-1x);border-radius:var(--border-radius-sm);box-shadow:var(--shadow-level-1);pointer-events:none;transition-property:transform,opacity,bottom,top,left,right;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);}", " ", " ", " ", ""], o, o, ({
  position: t
}) => t === r.Top && i`
            ${o} {
                left: 50%;
                transform: translateX(-50%);
                bottom: calc(100%);
            }
            &:hover {
                ${o} {
                    bottom: calc(100% + var(--spacing-1x));
                }
            }
        `, ({
  position: t
}) => t === r.Bottom && i`
            ${o} {
                left: 50%;
                transform: translateX(-50%);
                top: calc(100%);
            }

            &:hover {
                ${o} {
                    top: calc(100% + var(--spacing-1x));
                }
            }
        `, ({
  position: t
}) => t === r.Left && i`
            ${o} {
                top: 50%;
                transform: translateY(-50%);
                right: calc(100%);
            }

            &:hover {
                ${o} {
                    right: calc(100% + var(--spacing-1x));
                }
            }
        `, ({
  position: t
}) => t === r.Right && i`
            ${o} {
                top: 50%;
                transform: translateY(-50%);
                left: calc(100%);
            }

            &:hover {
                ${o} {
                    left: calc(100% + var(--spacing-1x));
                }
            }
        `), f = n.div.withConfig({
  displayName: "ChildrenContainer",
  componentId: "sc-10bagjr-2"
})(["position:relative;"]), b = d.forwardRef(({
  label: t = "",
  position: e = r.Top,
  children: s,
  ...c
}, p) => /* @__PURE__ */ a(m, { children: /* @__PURE__ */ l(v, { position: e, ref: p, "data-testid": "rango-tooltip", "data-rango-component": "rango-tooltip", "data-is-rango": !0, ...c, children: [
  /* @__PURE__ */ a(g, { id: "tooltip-info", role: "tooltip", children: t }),
  /* @__PURE__ */ a(f, { "aria-describedby": "tooltip-info", children: s })
] }) }));
b.displayName = "RangoTooltip";
export {
  b as RangoTooltip
};
